import React, { useState } from 'react';
import { enrollTraining } from '../services/api';
import toast from 'react-hot-toast';

const TrainingModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    courseName: '',
    companyName: '',
    experience: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);

  const courses = [
    'PowerFactory Advanced Course',
    'Generative AI in Engineering',
    'Ansys Workbench Masterclass'
  ];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await enrollTraining(formData);
      toast.success('Enrollment successful! Our training coordinator will contact you soon.');
      onClose();
      setFormData({
        fullName: '',
        email: '',
        phone: '',
        courseName: '',
        companyName: '',
        experience: '',
        message: ''
      });
    } catch (error) {
      toast.error(error.message || 'Enrollment failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(0,0,0,0.7)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 2000
    }} onClick={onClose}>
      <div style={{
        background: 'white',
        borderRadius: '24px',
        maxWidth: '500px',
        width: '90%',
        maxHeight: '90vh',
        overflow: 'auto',
        padding: '2rem',
        position: 'relative'
      }} onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} style={{
          position: 'absolute',
          top: '1rem',
          right: '1rem',
          background: 'none',
          border: 'none',
          fontSize: '1.5rem',
          cursor: 'pointer'
        }}>×</button>
        
        <h2>Enroll in Training</h2>
        <p style={{ color: 'var(--text-muted)', marginBottom: '1.5rem' }}>Choose your course and secure your seat today.</p>
        
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="fullName"
            placeholder="Full Name *"
            value={formData.fullName}
            onChange={handleChange}
            required
            style={{
              width: '100%',
              padding: '0.8rem',
              marginBottom: '1rem',
              border: '1px solid #E2E8F0',
              borderRadius: '8px'
            }}
          />
          <input
            type="email"
            name="email"
            placeholder="Email Address *"
            value={formData.email}
            onChange={handleChange}
            required
            style={{
              width: '100%',
              padding: '0.8rem',
              marginBottom: '1rem',
              border: '1px solid #E2E8F0',
              borderRadius: '8px'
            }}
          />
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number *"
            value={formData.phone}
            onChange={handleChange}
            required
            style={{
              width: '100%',
              padding: '0.8rem',
              marginBottom: '1rem',
              border: '1px solid #E2E8F0',
              borderRadius: '8px'
            }}
          />
          <select
            name="courseName"
            value={formData.courseName}
            onChange={handleChange}
            required
            style={{
              width: '100%',
              padding: '0.8rem',
              marginBottom: '1rem',
              border: '1px solid #E2E8F0',
              borderRadius: '8px'
            }}
          >
            <option value="">Select Course *</option>
            {courses.map((course, index) => (
              <option key={index} value={course}>{course}</option>
            ))}
          </select>
          <input
            type="text"
            name="companyName"
            placeholder="Company Name"
            value={formData.companyName}
            onChange={handleChange}
            style={{
              width: '100%',
              padding: '0.8rem',
              marginBottom: '1rem',
              border: '1px solid #E2E8F0',
              borderRadius: '8px'
            }}
          />
          <textarea
            name="message"
            placeholder="Additional Message"
            value={formData.message}
            onChange={handleChange}
            rows="3"
            style={{
              width: '100%',
              padding: '0.8rem',
              marginBottom: '1.5rem',
              border: '1px solid #E2E8F0',
              borderRadius: '8px'
            }}
          />
          <button type="submit" className="btn-primary" style={{ width: '100%' }} disabled={loading}>
            {loading ? 'Submitting...' : 'Enroll Now'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default TrainingModal;